export const methods = {
    pages: {
        content: {
            get: "localization.pages.content.get"},
        translations: {
            get: "localization.pages.translations.get"}},
    languages: {
        preferred: {
            get: "localization.languages.preferred.get"},
        interface: {
            list: "localization.languages.interface.list"},
        learning: {
            list: "localization.languages.learning.list"}},
    admin: {
        languages: {
            interface: {
                list: "localization.admin.languages.interface.list"},
            learning: {
                list: "localization.admin.languages.learning.list"},
            images: {
                create: "localization.admin.languages.images.create"},
            status: {
                update: "localization.admin.languages.status.update"}}}};


  export const typedMethods = {};
